import {type ModalProps, message, Modal} from 'antd';
import {useForm} from 'form-render';
import Style from './index.module.scss';
import {useMutation, useQuery} from 'react-query';
import {isEmpty} from '../../../../../Stores/commonStore';
import useSchema from 'Utils/Hooks/useSchema';
import JsonForm from 'Components/JsonForm';
import {Mcp} from '../../service';

interface Props extends ModalProps {
    onOk: () => void;
    id?: string;
}

const Index = ({onOk, id, ...props}: Props) => {
    const form = useForm();

    const onSave = useMutation({
        mutationFn: Mcp.save,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    const getData = useQuery({
        queryKey: ['Mcp.detail', id],
        enabled: !isEmpty(id),
        queryFn: () => Mcp.detail(id!),
        onSuccess: res => {
            form.setValues(res);
        },
    });

    const {schema} = useSchema({
        type: 'object',
        column: 1,
        displayType: 'row',
        labelCol: 5,
        fieldCol: 18,
        properties: {
            name: {
                title: '名称',
                required: true,
                type: 'string',
            },
            code: {
                title: '编码',
                required: true,
                type: 'string',
                disabled: !isEmpty(id),
            },
            baseUrl: {
                title: '基础Url',
                required: true,
                type: 'string',
            },
            listenUrl: {
                title: '监听Url',
                required: true,
                type: 'string',
            },
            description: {
                type: 'string',
                title: '描述',
                widget: 'textArea',
            },
            status: {
                required: true,
                type: 'boolean',
                title: '启用',
                widget: 'switch',
                defaultValue: true,
            },
        },
    });

    function onFinish(formData: Mcp.Form) {
        if (id) {
            formData.id = id;
        }
        onSave.mutate({...formData});
    }

    return (
        <Modal
            {...props}
            title={`${id ? '编辑' : '新增'}Mcp`}
            width={600}
            confirmLoading={onSave.isLoading || getData.isFetching}
            onOk={form.submit}>
            <div className={Style.root}>
                <JsonForm
                    loading={onSave.isLoading || getData.isFetching}
                    onFinish={onFinish}
                    schema={schema}
                    form={form}
                />
            </div>
        </Modal>
    );
};

export default Index;
